export class ObjectUtils {

  // return true if === {}
  static isEmptyObject(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  // source: https://stackoverflow.com/a/53022904/3086147
  static mergeArrayOfObjects(arrayOfObjects) {
    let result = {};
    arrayOfObjects.forEach(row => {
      Object.keys(row).forEach(key => {
        result[key] = !result[key]
          ? [row[key]]
          : [...result[key], row[key]];
      });
    });
    return result;
  }

  static initializeObjectAttributes(obj, attributes: string[]) {
    for (const attribute of attributes) {
      if (!obj[attribute]) {
        obj[attribute] = [];
      }
    }
    return obj;
  }

  // https://stackoverflow.com/a/40294058/3086147
  static deepClone(obj, hash = new WeakMap()) {
      if (Object(obj) !== obj) return obj; // primitives
      if (hash.has(obj)) return hash.get(obj); // cyclic reference
      const result = obj instanceof Set ? new Set(obj) // See note about this!
                  : obj instanceof Map ? new Map(Array.from(obj, ([key, val]) => 
                                          [key, this.deepClone(val, hash)])) 
                  : obj instanceof Date ? new Date(obj)
                  : obj instanceof RegExp ? new RegExp(obj.source, obj.flags)
                  // ... add here any specific treatment for other classes ...
                  // and finally a catch-all:
                  : obj.constructor ? new obj.constructor() 
                  : Object.create(null);
      hash.set(obj, result);
      return Object.assign(result, ...Object.keys(obj).map(
          key => ({ [key]: this.deepClone(obj[key], hash) }) ));
  }

  static deepCompare () {
  var i, l, leftChain, rightChain;

  // https://stackoverflow.com/a/1144249/3086147
  function compare2Objects (x, y) {
    var p;

    // remember that NaN === NaN returns false
    // and isNaN(undefined) returns true
    if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
         return true;
    }

    // Compare primitives and functions.     
    // Check if both arguments link to the same object.
    // Especially useful on the step where we compare prototypes
    if (x === y) {
        return true;
    }

    // Works in case when functions are created in constructor.
    // Comparing dates is a common scenario. Another built-ins?
    // We can even handle functions passed across iframes
    if ((typeof x === 'function' && typeof y === 'function') ||
       (x instanceof Date && y instanceof Date) ||
       (x instanceof RegExp && y instanceof RegExp) ||
       (x instanceof String && y instanceof String) ||
       (x instanceof Number && y instanceof Number)) {
        return x.toString() === y.toString();
    }

    // At last checking prototypes as good as we can
    if (!(x instanceof Object && y instanceof Object)) {
        return false;
    }

    if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
        return false;
    }

    if (x.constructor !== y.constructor) {
        return false;
    }

    if (x.prototype !== y.prototype) {
        return false;
    }

    // Check for infinitive linking loops
    if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
         return false;
    }

    // Quick checking of one object being a subset of another.
    // todo: cache the structure of arguments[0] for performance
    for (p in y) {
        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
            return false;
        }
        else if (typeof y[p] !== typeof x[p]) {
            return false;
        }
    }

    for (p in x) {
        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
            return false;
        }
        else if (typeof y[p] !== typeof x[p]) {
            return false;
        }

        switch (typeof (x[p])) {
            case 'object':
            case 'function':

                leftChain.push(x);
                rightChain.push(y);

                if (!compare2Objects (x[p], y[p])) {
                    return false;
                }

                leftChain.pop();
                rightChain.pop();
                break;

            default:
                if (x[p] !== y[p]) {
                    return false;
                }
                break;
        }
    }

    return true;
  }

  if (arguments.length < 1) {
    return true; //Die silently? Don't know how to handle such case, please help...
    // throw "Need two or more arguments to compare";
  }

  for (i = 1, l = arguments.length; i < l; i++) {

      leftChain = []; //Todo: this can be cached
      rightChain = [];

      if (!compare2Objects(arguments[0], arguments[i])) {
          return false;
      }
  }

  return true;
}

}